export const LEGACY_HOSTING_PLAN = "dedicated-server-hosting";
export const HOSTING_2GB_PLAN = "dedicated-server-hosting-2gb";

export const HOSTING_PLAN_NAMES = {
  [LEGACY_HOSTING_PLAN]: "Gen 1 Server",
  [HOSTING_2GB_PLAN]: "Gen 2 Server",
};

export const SERVER_GENERATION_NAMES = {
  "s-1vcpu-1gb": "Gen 1 Server",
  "s-1vcpu-2gb": "Gen 2 Server",
};